import React, { FC, useCallback, useContext, useState } from 'react';
import { Box } from '@src/atoms/Box';
import { Skeleton } from '@src/atoms/Skeleton';
import { IClassNameProps, IStylesProps } from '@src/models/props';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { COEFF } from '../const';

interface IProps extends IClassNameProps, IStylesProps {}

/** Компонент для отображения состояния загрузки карточки продукта */
export const GallerySkeleton: FC<IProps> = ({ className }) => {
  const [height, setHeight] = useState<string | number>('100%');
  const { isMobile } = useContext(BreakpointsContext);

  const handleSetRef = useCallback((e: HTMLDivElement) => {
    const rect = e?.getBoundingClientRect();
    rect?.width && setHeight(rect.width / COEFF);
  }, []);

  return (
    <Box column alignItems="center" ref={handleSetRef} gap={8} marginLeft={{ DESKTOP: 8 }} marginRight={{ DESKTOP: 8 }}>
      <Box style={{ height }} className={className} fullWidth>
        <Skeleton.Rect ry={8} rx={8} height={height} />
      </Box>
      <Box gap={8} style={{ width: '70%' }} justifyContent="center">
        {Array.from(Array(4).keys()).map((_, index) => (
          <Box key={index}>
            {isMobile ? <Skeleton.Circle radius={8} /> : <Skeleton.Rect ry={8} rx={8} height={45} />}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
